if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.productID = this.dataset.productId;
        this.slider = this.querySelector(`.swiper-${this.productID}`);
        this.zoomContainer = this.querySelector('[data-zoom]');
        this.zoomImagesPlaceholder = this.querySelector('[ data-zoom-container]');
        this.closeZoomButton = this.querySelector('[data-close-zoom]');
        this.videos = this.querySelectorAll('video');
      }

      get isDesktopSlider() {
        return this.hasAttribute('data-slider-desktop');
      }

      get zoomEnabled() {
        return this.hasAttribute('data-zoom');
      }

      connectedCallback() {
        this.initSlider();
        this.zoomComponent();
      }

      initSlider() {
        let Slider;
        if (!this.slider) return;
        const scrollBar = this.slider.querySelector('.product-gallery--scrollbar');
        const nextButton = this.querySelector('.button-next');
        const prevButton = this.querySelector('.button-prev');

        const options = {
          slidePerView: 1,
          slidePerMove: 1,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
          },
          scrollbar: {
            el: scrollBar,
            draggable: true,
            dragSize: 'auto',
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
        };
        if (this.isDesktopSlider) {
          Slider = new Swiper(this.slider, options);
        } else {
          if (window.innerWidth < 990) {
            Slider = new Swiper(this.slider, options);
          }
        }
        if (this.videos.length === 0) return;
        this.videos.forEach((video) => {
          this.observVideo(video);
        });
        if (window.innerWidth < 990 || !this.isDesktopSlider) return;
        this.slider.addEventListener('mouseenter', () => {
          if (Slider.activeIndex >= 1) return;
          Slider.slideTo(1, 300);
        });
        this.slider.addEventListener('mouseleave', () => {
          if (Slider.activeIndex === 0) return;
          Slider.slideTo(0, 300);
        });
      }

      zoomComponent() {
        if (!this.zoomEnabled) return;
        this.openZoom();
        this.closeZoom();
      }

      openZoom() {
        const zoomElements = this.querySelectorAll('[data-zoomed-item]');
        if (zoomElements.length === 0) return;
        zoomElements.forEach((el) => {
          el.addEventListener('click', () => {
            const id = el.dataset.id;
            this.prepaImagesForZoom(zoomElements);
            this.enableAdditionalZoom();
            this.zoomContainer.classList.remove('hidden');
            this.setActiveImage(id);
          });
        });
      }

      prepaImagesForZoom(zoomElements) {
        zoomElements.forEach((el) => {
          const itemToAdd = el.cloneNode(true);
          itemToAdd.classList.remove('swiper-slide');
          if (itemToAdd.hasAttribute('style')) {
            itemToAdd.removeAttribute('style');
          }
          itemToAdd.classList.add('is-zoomable');
          if (!el.hasAttribute('data-video-el')) {
            const image = itemToAdd.querySelector('img');
            image.remove();
            const imageToReplace = window.innerWidth < 990 ? window.atob(el.dataset.zoomSrcMobile) : window.atob(el.dataset.zoomSrcDesktop);
            itemToAdd.querySelector('div').innerHTML = imageToReplace;
          } else {
            const video = itemToAdd.querySelector('video');
            video.setAttribute('autoplay', true);
            video.setAttribute('loop', true);
            itemToAdd.removeAttribute('data-zoomed-item');
          }
          this.zoomImagesPlaceholder.insertAdjacentElement('beforeend', itemToAdd);
        });
      }

      setActiveImage(id) {
        const activeImage = this.zoomImagesPlaceholder.querySelector(`[data-id="${id}"]`);
        if (!activeImage) return;
        const srollPosition = activeImage.offsetTop;
        this.zoomImagesPlaceholder.scrollTo({
          top: srollPosition,
          behavior: 'smooth',
        });
      }

      enableAdditionalZoom() {
        const images = this.zoomImagesPlaceholder.querySelectorAll('[data-zoomed-item]');
        if (images.length === 0) return;
        images.forEach((image) => {
          image.addEventListener('click', () => {
            const img = image.querySelector('img');
            image.classList.toggle('zoom-active');
            if (image.classList.contains('zoom-active')) {
              img.style.cssText = `width: ${img.getAttribute('width')}px; height: ${img.getAttribute('height')}px;`;
            } else {
              img.removeAttribute('style');
            }
          });
        });
      }

      closeZoom() {
        if (!this.closeZoomButton) return;
        this.closeZoomButton.addEventListener('click', () => {
          this.zoomContainer.classList.add('hidden');
          this.zoomImagesPlaceholder.innerHTML = '';
        });
      }

      observVideo(video) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            });
          },
          {
            threshold: window.innerWidth >= 990 ? 0.6 : 0.95,
          },
        );
        observer.observe(video);
      }
    },
  );
}